/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getItemDisputationType } from '../fn/item-item-disputation-type-controller/get-item-disputation-type';
import { GetItemDisputationType$Params } from '../fn/item-item-disputation-type-controller/get-item-disputation-type';
import { ItemDisputationType } from '../models/item-disputation-type';

@Injectable({ providedIn: 'root' })
export class ItemItemDisputationTypeControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `itemItemDisputationTypeControllerGetItemDisputationType()` */
  static readonly ItemItemDisputationTypeControllerGetItemDisputationTypePath = '/items/{id}/item-disputation-type';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getItemDisputationType()` instead.
   *
   * This method doesn't expect any request body.
   */
  getItemDisputationType$Response(params: GetItemDisputationType$Params, context?: HttpContext): Observable<StrictHttpResponse<ItemDisputationType>> {
    return getItemDisputationType(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getItemDisputationType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getItemDisputationType(params: GetItemDisputationType$Params, context?: HttpContext): Observable<ItemDisputationType> {
    return this.getItemDisputationType$Response(params, context).pipe(
      map((r: StrictHttpResponse<ItemDisputationType>): ItemDisputationType => r.body)
    );
  }

}
